/* eslint-disable prettier/prettier */
/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable react/prop-types */
import styled from '@emotion/styled';
// import CustomAlert from 'components/alerts/CustomAlert';
import Avatar from 'components/base/Avatar';
import Button from 'components/base/Button';
import PageLoader from 'components/custom/animate-component/PageLoader';
import LabelSelector from 'components/custom/forms/LabelSelector';
import Selector from 'components/custom/forms/Selector';
import Icon from 'components/icon';
import apiEndpoints from 'constants/apiEndpoints';
import { useFormik } from 'formik';
import useFetchData from 'hooks/custom/useFetchData';
import { useAlert } from 'providers/AlertModalProvider';
import { useEffect, useState } from 'react';
import { Form } from 'react-bootstrap';
import { Col, Row } from 'react-bootstrap';
import { Modal } from 'react-bootstrap';
// import postData from 'services/postData';
import fetchData from 'services/fetchData';
import postData from 'services/postData';
import * as Yup from 'yup';
import { findIndividual, formatDate, formatTimeToAmPm } from 'services/utils';
import LabelInput from 'components/custom/forms/LabelInput';

const CustomModal = styled(Modal)`
  background-color: #0000004b;
  backdrop-filter: blur(2px);
  & .modal-dialog {
    /* max-width: 300px !important; */
    margin-right: auto;

    margin-left: auto;
  }
  & .modal-header .btn-close {
    background-color: #ffffff39;
  }
`;

const CreateQuickDriver = ({
  show,
  handleClose,
  data,
  refreshData,
  truckerId,
  transFor,
  handleRefresh,
  setId,
  vehicleId
}) => {
  const [loading, setLoading] = useState(false);
  const [DriverList, setDriverList] = useState([]);
  const [shiftOption] = useFetchData(apiEndpoints.shift.getAll);
  const { showAlert } = useAlert();

  const formik = useFormik({
    initialValues: {
      driver_name: '',
      driver_mobile: '',
      license_number: '',
      pan: '',
      driver_upi_id: '',
      driver_upi_name: '',
      // shift_id: '',
      adhar: '',
      trucker_id: truckerId,
      vehicle_id: vehicleId
    },
    validationSchema: Yup.object({
      driver_name: Yup.string().required('Driver Name is required'),
      driver_mobile: Yup.number().required('Driver Number is required'),
      license_number: Yup.string().required('Licence Number is required'),
      pan: Yup.string().required('PAN Number is required'),
      driver_upi_id: Yup.string().required('DriverUPI Id is required'),
      // shift_id: Yup.string().required('DriverUPI Id is required'),
      driver_upi_name: Yup.string(),
      adhar: Yup.string(),
      trucker_id: Yup.number(),
      vehicle_id: Yup.number()
    }),
    onSubmit: async values => {
      setLoading(true);
      try {
        const response = await postData(
          values,
          apiEndpoints.driver.createQuickDriver
        );
        if (response?.status) {
          showAlert({
            variant: 'success',
            message: 'The Driver has been Created successfully.'
          });
          // refreshData();
          setId(response?.data?.driver?.driver_id);

          handleRefresh();
          handleClose();
        } else {
          let errorObj = response.errors;
          if (errorObj) {
            formik.setErrors(
              Object.keys(response.errors)?.reduce(
                (acc, er) => ({ ...acc, [er]: errorObj[er][0] }),
                {}
              )
            );
          }
          showAlert({
            variant: 'danger',
            message: 'Failed to Create Driver.'
          });
        }
      } catch (error) {
        showAlert({
          variant: 'danger',
          message: 'An unexpected error occurred. Please try again.'
        });
      } finally {
        setLoading(false);
      }
    }
  });
  return (
    <>
      <Form onSubmit={formik.handleSubmit}>
        <Modal.Header
          className="border-0 position-relative pb-0 end-0 dark__text-white"
          closeButton={!loading}
        >
          <div className="d-flex align-items-center mb-2">
            <Avatar size="xl" variant="name" className="me-2">
              <Icon icon={'icon-park-outline:add-user'} fontSize="18px" />
            </Avatar>
            Driver
          </div>
        </Modal.Header>

        <Modal.Body className="pt-2 position-relative">
          <Row className="">
            <Col className="mt-3" xs={12} sm={6} lg={6}>
              <LabelInput
                label={'Driver Name'}
                errorProps={{ tooltip: false }}
                controlId={'driver_name'}
                required={true}
                formik={formik}
              />
            </Col>
            <Col className="mt-3" xs={12} sm={6} lg={6}>
              <LabelInput
                label={'Contact No.'}
                inputProps={{ type: 'number' }}
                errorProps={{ tooltip: false }}
                controlId={'driver_mobile'}
                required={true}
                formik={formik}
              />
            </Col>

            <Col className="mt-3" xs={12} sm={6} lg={6}>
              <LabelInput
                label={'Licience No.'}
                // inputProps={{ readOnly: true }}
                errorProps={{ tooltip: false }}
                controlId={'license_number'}
                required={true}
                formik={formik}
              />
            </Col>

            <Col className="mt-3" xs={12} sm={6} lg={6}>
              <LabelInput
                errorProps={{ tooltip: false }}
                controlId={'pan'}
                required
                label={'PAN No'}
                formik={formik}
                inputProps={{ placeholder: 'AAAAA0000A' }}
                formatter={'AAAAA0000A'}
              />
            </Col>

            <Col className="mt-3" xs={12} sm={6} lg={6}>
              <LabelInput
                label={'UPI Id'}
                // inputProps={{ readOnly: true }}
                errorProps={{ tooltip: false }}
                controlId={'driver_upi_id'}
                required={true}
                formik={formik}
              />
            </Col>
            <Col className="mt-3" xs={12} sm={6} lg={6}>
              <LabelInput
                label={'UPI Name'}
                // inputProps={{ readOnly: true }}
                errorProps={{ tooltip: false }}
                controlId={'driver_upi_name'}
                required={true}
                formik={formik}
              />
            </Col>
            {/* <Col className="mt-3" xs={12} sm={6} lg={6}>
              <LabelSelector
                errorProps={{ tooltip: false }}
                options={{
                  data: shiftOption,
                  formatter: option => ({
                    label: option.shift_name,
                    value: option.shift_id,
                    desc: `${formatTimeToAmPm(option.start_time)} - ${formatTimeToAmPm(option.end_time)}`
                  })
                }}
                allowFooter={true}
                newBtnText={'New Shift'}
                label={'Shift'}
                controlId={'shift_id'}
                required
                formik={formik}
                placeholder={'Select Shift'}
              />
            </Col> */}
            <Col className="mt-3" xs={12} sm={6} lg={6}>
              <LabelInput
                label={'Aadhar No.'}
                // inputProps={{ readOnly: true }}
                errorProps={{ tooltip: false }}
                controlId={'adhar'}
                required={false}
                formik={formik}
              />
            </Col>
          </Row>
        </Modal.Body>
        <Modal.Footer className="d-flex justify-content-center">
          <Button
            variant="phoenix-secondary"
            disabled={loading}
            onClick={handleClose}
          >
            Cancel
          </Button>
          <Button variant="phoenix-success" type="submit" disabled={loading}>
            Create and Select
          </Button>
        </Modal.Footer>
      </Form>

      <PageLoader loading={loading} loadingMessage={'Assigning vehicle'} />
    </>
  );
};

export default CreateQuickDriver;
